<template>
  <div>
    <CForm @submit.prevent="submit">
      <CModal
        centered
        :close-on-backdrop="false"
        :show.sync="properties.visible"
      >
        <ValidationObserver ref="observer">
          <CRow>
            <CCol col="12" sm="6">
              <div class="d-flex flex-column p-3">
                <VueSvgGauge
                  :start-angle="-120"
                  :end-angle="120"
                  :value="getGaugeValue(properties.params.item.value)"
                  :separator-step="0"
                  :min="0"
                  :max="100"
                  :gauge-color="getGaugeColor(properties.params.item.status)"
                  :scale-interval="0.1"
                >
                  <div class="inner-text">
                    <span style="margin-top: 20px">
                      {{ getGaugeValue(properties.params.item.value) }}%
                    </span>
                  </div>
                </VueSvgGauge>
                <div
                  class="label bg-color-blue-light scc-rounded pl-2 pr-2 w-100 text-center mt-2"
                >
                  {{ properties.params.item.name }}
                </div>
              </div>
            </CCol>
            <CCol col="12" sm="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="percent"
                rules="required|minValue:0|maxValue:100"
              >
                <CInput
                  type="number"
                  placeholder="개도율"
                  v-model="form.percent"
                  :invalid-feedback="errors.length > 0 ? errors[0] : ''"
                  :is-valid="errors.length > 0 ? false : null"
                >
                  <template #append>
                    <CButton type="submit" color="primary">제어</CButton>
                  </template>
                </CInput>
              </ValidationProvider>
              <CButtonGroup style="width: 100%">
                <CButton color="primary" @click="controlSwitch('open')">열기</CButton>
                <CButton color="danger" @click="controlSwitch('close')">닫기</CButton>
                <CButton color="success" @click="controlSwitch('stop')">정지</CButton>
              </CButtonGroup>
            </CCol>
          </CRow>
        </ValidationObserver>

        <template #header>
          <h5 class="modal-title" v-html="properties.params.item.name"></h5>
          <CButtonClose @click="properties.visible = false"></CButtonClose>
        </template>
        <template #footer>
          <CButton @click="properties.visible = false" color="secondary">
            취소
          </CButton>
        </template>
      </CModal>
    </CForm>
  </div>
</template>

<script>
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import { max_value, min_value, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import core from "@/core";
import ControlService from "@/services/control/control.service";
import MixinsModalBackButton from "@/mixins/modal-back-button";

extend("required", required);
extend("minValue", min_value);
extend("maxValue", max_value);

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    percent: "개도율",
  },
});

export default {
  name: "SwitchControlModal",
  mixins: [MixinsModalBackButton()],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          visible: false,
          params: {},
          watchClose: {
            result: "",
            item: null,
          },
        };
      },
    },
  },
  data() {
    return {
      form: {
        percent: "",
      },
    };
  },
  methods: {
    getGaugeColor(status) {
      if (status === "open") return "#2d6ba6";
      else if (status === "close") return "#9e0625";
      else if (status === "stop") return "#459245";
      else return "#000000";
    },
    getGaugeValue(value) {
      if (value < 0) return 0;
      else if (100 < value) return 100;
      return value;
    },
    changeValue(changed) {
      const $this = this;
      if (changed != null) {
        $this.backButton.changed = changed;
      } else {
        $this.backButton.changed = true;
      }
    },
    async controlSwitch(status) {
      try {
        core.loader.show();
        const result = await ControlService.controlNareState(
          this.properties.params.item,
          status,
        );
        console.log("result : ", result);
      } catch (e) {
        console.log(e);
      }
      core.loader.hide();
    },
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        try {
          const result = await ControlService.controlNareOpenRate(
            this.properties.params.item,
            this.form.percent,
          );
          console.log("result : ", result);
        } catch (e) {
          console.log("error : ", e);
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
        core.loader.hide();
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
